import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'

const state = {}

const mutations = {}

const getters = {}

const actions = {
  updateParam({ state }, { key, data }) {
    const character = state.items[key]
    if (!character) return
    const params = state.$clone(character.params)
    params[data.key] = ~~(params[data.key]) + ~~(data.value)
    const nextData = Object.assign({ params, timestamp: state.$timestamp() })
    return state.$collection.doc(key).set(nextData, { merge: true })
  },
  setParam({ state }, { key, data }) {
    const character = state.items[key]
    if (!character) return
    const params = state.$clone(character.params)
    params[data.key] = ~~(data.value)
    const nextData = Object.assign({ params, timestamp: state.$timestamp() })
    return state.$collection.doc(key).set(nextData, { merge: true })
  },
  setPos({ state }, { key, data }) {
    return state.$collection.doc(key).set({
      x: data.x,
      y: data.y,
      timestamp: state.$timestamp()
    }, { merge: true })
  }
}

function migrationParams(params = {}) {
  const res = {}
  Object.keys(params).forEach((key) => {
    if (typeof params[key] !== 'object') {
      res[key] = Number(params[key])
    } else {
      res[key] = Number(params[key].value)
    }
  })
  return res
}

function formatter({ characterKey, params, x = 0, y = 0, timestamp }) {
  return {
    characterKey,
    params: migrationParams(params),
    x: x,
    y: y,
    z: 0,
    w: null,
    h: null,
    timestamp
  }
}

export default new FirestoreCollectionStore({
  $name: 'characterList',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})
